<template>
  <div id="NewsInformation">
    <div class="row">
      <div class="content col-md-12" v-for="(item, index) in newsList" :key="index">
        <div class="time" v-if="item.openTime">{{ item.openTime.split(' ')[0] }}</div>
        <div class="events">
          <div class="hidden-xs hidden-sm events-body">
            <div class="event-img">
              <img :src="item.img" alt="" v-if="item.img">
              <img src="../../assets/img/newsInformation/newsInformation.png" alt="" v-else>
            </div>
            <div class="title">
              {{ item.title }}
              <div class="learn" @click="$router.push(`/companynews/details?id=${item.id}`)">
                <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
                <span>了解更多</span>
              </div>
            </div>
          </div>
          <div class="hidden-md hidden-lg" @click="$router.push(`/companynews/details?id=${item.id}`)">
            <!-- <div class="events-header">
                <div>{{ item.title }}</div>
              </div> -->
            <div class="events-body">
              <img :src="item.img" alt="" v-if="item.img">
              <img src="../../assets/img/newsInformation/newsInformation.png" alt="" v-else>
              <p class="title">{{ item.title }}</p>
            </div>
            <div class="learn">
              <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
              <span>了解更多</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "NewsInformation",
  data() {
    return {
      yearActive: 0,
      newsList: [],
    };
  },
  mounted() {
    var wow = new WOW();
    wow.init();
    this.init()
  },
  methods: {
    init() {
      this.http({
        url: this.http.adornUrl('/pc/news/list?typeId=2'),
        method: 'get'
      }).then(({ data }) => {
        this.newsList = data
      })
    },
    createTime(date, type) {
      let year = ''
      let month = ''
      let day = ''
      year = date.split(' ')[0].split('-')[0]
      month = date.split(' ')[0].split('-')[1]
      day = date.split(' ')[0].split('-')[2]
      if (type === 'year') {
        return year
      } else {
        return month + '-' + day
      }
    }
  }
};
</script>
<style scoped>
.container {
  /* padding-bottom: 20px; */
}

.content:first-child {
  border-top: 1px solid #989898;
}

.content {
  box-sizing: border-box;
  padding: 25px 0;
}

.time {
  font-size: 18px;
}

.events {
  padding-bottom: 25px;
  border-bottom: 1px solid #989898;
}

.events .events-header {
  min-height: auto;
  text-align: left;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
}

.events .events-header div {
  min-height: 30px;
  line-height: 20px;
  font-size: 16px;
  font-weight: bold;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
}

.events .hidden-xs.events-body {
  display: flex;
  min-height: auto;
  text-align: left;
}

.events .events-body img {
  height: 150px;
  width: 225px;
}

.events .events-body .event-img {
  width: 23%;
}

.events .events-body .title {
  flex: 1;
  min-height: 30px;
  line-height: 20px;
  font-size: 18px;
  font-weight: bold;
}

.learn {
  margin-top: 15px;
  color: black;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
}


.learn span {
  margin-right: 10px;
}


.learn:hover {
  color: #f50f10;
}

.container,
.container .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}

@media screen and (max-width: 768px) {
  .learn:hover {
    color: #000;
  }

  .events .events-header div {
    margin-bottom: 10px;
  }

  .events .events-body img {
    margin: 10px auto;
  }

  .learn {
    font-size: 15px;
  }

}
</style>




// WEBPACK FOOTER //
// src/view/NewsInformation/IndustryTrends.vue